import React, {Component} from "react";
import './AllSalesTable.css';
import {FormattedMessage} from "react-intl";
import SalesTableRow from "../SalesTableRow/SalesTableRow";
import SalesTableHeader from "../SalesTableHeader/SalesTableHeader";
import AllSalesBottom from "../AllSalesBottom/AllSalesBottom";
import {ITEM_COUNT_PER_PAGE, RESOURCE_BASE_URL} from "../../../../../configuration";
import axios from "axios";
import SalesTableHeaderRes from "../SalesTableHeader/salesTableHeaderRes";

class AllOrdersTable extends Component {

    constructor(props) {
        super(props);
        this.state = {
            orders: [],
            totalItemCount: 0,
            activePage: 1,
            allOrderCount: 0,
            dollarAmount: 0.0,
            totalAmount: 0.0,
            filterFrom: "",
            filterTo: "",
            searchData: {
                searchFlag: "createdDate",
                statusCodes: [],
                searchStartDate: null,
                searchEndDate: null,
                page: 0,
                size: 5
            },
            hideOrderStatus: false
        };
        this.handlePageChange = this.handlePageChange.bind(this);
        this.getAllOrders = this.getAllOrders.bind(this);
        this.getAllOrdersByDateRange = this.getAllOrdersByDateRange.bind(this);
        this.getFilteredOrdersByDateRange = this.getFilteredOrdersByDateRange.bind(this);
        this.searchOrders = this.searchOrders.bind(this);
        this.setSearchTimePeriod = this.setSearchTimePeriod.bind(this);
        this.setSearchStatus = this.setSearchStatus.bind(this);
        this.formatDate = this.formatDate.bind(this);
        this.setSearchTimeRange = this.setSearchTimeRange.bind(this);
        this.getFilteredOrders = this.getFilteredOrders.bind(this);
        this.addStatusToArray = this.addStatusToArray.bind(this);
        this.removeStatusFromArray = this.removeStatusFromArray.bind(this);
        this.exportSalesToCsv = this.exportSalesToCsv.bind(this);
        this.base64ToArrayBuffer = this.base64ToArrayBuffer.bind(this);
        this.saveByteArray = this.saveByteArray.bind(this);
        this.handleSearchType = this.handleSearchType.bind(this);
    }

    handleSearchType = (event) => {
        let searchData = {...this.state.searchData};
        let hideOrderStatus = false;
        if (event.target.value === "shippedDate") {
            hideOrderStatus = true;
        } else {
            searchData.statusCodes = ["PENDING", "IN_PRODUCTION", "IN_WAREHOUSE", "SHIPPED", "DELIVERED"];
        }
        console.log("SEARCH TYPE DUO =====> ", event.target.value);

        searchData.searchFlag = event.target.value;
        this.setState({
            searchData,
            hideOrderStatus
        }, () => this.getFilteredOrders());
    };

    handlePageChange = (pageNumber) => {

        this.setState({activePage: pageNumber});

        let offset = (pageNumber - 1) * ITEM_COUNT_PER_PAGE;

        let searchData = {...this.state.searchData};
        searchData.page = pageNumber - 1;
        this.setState({
            searchData
        }, () => this.getFilteredOrders())
    };

    componentDidMount() {
        // this.getAllOrders(0, ITEM_COUNT_PER_PAGE);

        let todayDate = new Date();

        let today = this.formatDate(todayDate);
        let searchData = {...this.state.searchData};
        searchData.searchStartDate = today;
        searchData.searchEndDate = null;
        searchData.statusCodes = ["PENDING", "IN_PRODUCTION", "IN_WAREHOUSE", "SHIPPED", "DELIVERED"];
        searchData.searchStartDate = today;
        // let days = todayDate.getDate() - 2;
        // todayDate.setDate(days);
        // searchData.searchStartDate = this.formatDate(todayDate);

        this.setState({
            searchData
        }, () => this.getFilteredOrders());

        // console.log("MOUNTED");

    }

    searchOrders = () => {
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };

        let searchData = {...this.state.searchData};

        axios.post(RESOURCE_BASE_URL + 'api/multi-search', searchData, axiosConfig)
            .then((res) => {
                // console.log(res.data);
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });
    };

    formatDate = (date) => {
        let today = new Date(date);

        let todayPlus = today.getDate();
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),

            day = '' + todayPlus,

            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    };

    setSearchTimePeriod = (period) => {
        let periodCode = period;
        // console.log("PERIODaaaa ====> ", periodCode);

        let today_date = new Date();
        console.log("today", today_date);
        // console.log("TODAY DATE ====> ", today_date.getFullYear()+"-"+today_date.getUTCMonth()+"-"+today_date.getDay());
        let todayDate = new Date();
        let today = this.formatDate(today_date);

        let week = new Date(todayDate.setDate(todayDate.getDate() - 7));
        let month = new Date(todayDate.getFullYear(), new Date().getMonth(), -1);
        let year = new Date(new Date().getFullYear(), 0, -1);

        let beforeWeek = this.formatDate(week);
        let beforeMonth = this.formatDate(month);
        let beforeYear = this.formatDate(year);

        let searchData = {...this.state.searchData};
        searchData.searchEndDate = today;
        if (periodCode == 1) {
            let dateBeforeToday = new Date();
            dateBeforeToday.setDate(dateBeforeToday.getDate() - 1);

            /*searchData.searchStartDate = this.formatDate(dateBeforeToday);
            searchData.searchEndDate = today;*/
            searchData.searchStartDate = today;
            searchData.searchEndDate = null;
        } else if (periodCode == 2) {
            searchData.searchStartDate = beforeWeek;
            searchData.searchEndDate = today
        } else if (periodCode == 3) {
            searchData.searchStartDate = beforeMonth;
            searchData.searchEndDate = today
            // console.log("BLA BLA BLA")
        } else if (periodCode == 4) {
            searchData.searchStartDate = beforeYear;
            searchData.searchEndDate = today;
        } else if (periodCode === "全て") {
            searchData.searchStartDate = null;
            searchData.searchEndDate = null;
        }

        this.setState({
            searchData
        }, () => this.getFilteredOrders());
    };

    setSearchTimeRange = (name, value) => {
        // console.log("DATE VALUE =====> ", value);

        let today_date = new Date();
        // console.log("TODAY DATE ====> ", today_date.getFullYear()+"-"+today_date.getUTCMonth()+"-"+today_date.getDay());
        let today = this.formatDate(today_date);

        let years = today_date.getFullYear() - 100;


        let searchData = {...this.state.searchData};
        if (name === "from") {
            searchData.searchStartDate = value;
            if (value === null) {
                searchData.searchStartDate = this.formatDate(new Date("1920-01-01"));
            }
        } else {
            searchData.searchEndDate = value;
            if (value === null) {
                searchData.searchEndDate = today_date;
            }
        }

        this.setState({
            searchData
        }, () => this.getFilteredOrders());
    };

    addStatusToArray = (array1, array2) => {
        let newArray = array1.concat(array2);

        // removing duplicates
        return Array.from(new Set(newArray));
    };

    removeStatusFromArray = (array1, array2) => {
        let myArray = array1;
        myArray = myArray.filter((el) => {
            return array2.indexOf(el) < 0;
        });
        return myArray;
    };

    setSearchStatus = (event) => {
        //
        // frontend status codes
        // all -> 0
        // pending -> 1
        // in progress -> 2
        // completed -> 3

        let statusCode = event.target.value;
        let checked = event.target.checked;
        // console.log("STATUS CODE ===> ",event.target.value);

        // let pending = [0,2,3];
        let inProgress = ["IN_PRODUCTION"];
        let completed = ["DELIVERED"];
        let pending = ["PENDING"];
        let warehouse = ["IN_WAREHOUSE"];
        let shipped = ["SHIPPED"];
        let all = ["PENDING", "IN_PRODUCTION", "IN_WAREHOUSE", "SHIPPED", "DELIVERED"];

        let searchData = {...this.state.searchData};

        let status = [];

        if (checked) {
            if (statusCode == 0) {
                status = this.addStatusToArray(searchData.statusCodes, all);
            }
            // else if(statusCode == 1){
            //     status= this.addStatusToArray(searchData.statusCodes, pending);
            // }
            else if (statusCode == "IN_PRODUCTION") {
                status = this.addStatusToArray(searchData.statusCodes, inProgress);
            } else if (statusCode == "DELIVERED") {
                status = this.addStatusToArray(searchData.statusCodes, completed);
            } else if (statusCode == "PENDING") {
                status = this.addStatusToArray(searchData.statusCodes, pending);
            } else if (statusCode == "IN_WAREHOUSE") {
                status = this.addStatusToArray(searchData.statusCodes, warehouse);
            } else if (statusCode == "SHIPPED") {
                status = this.addStatusToArray(searchData.statusCodes, shipped);
            }
        } else {
            if (statusCode == 0) {
                status = this.removeStatusFromArray(searchData.statusCodes, all);
            }
            // else if(statusCode == 1){
            //     status= this.removeStatusFromArray(searchData.statusCodes, pending);
            // }
            else if (statusCode == "IN_PRODUCTION") {
                status = this.removeStatusFromArray(searchData.statusCodes, inProgress);
            } else if (statusCode == "DELIVERED") {
                status = this.removeStatusFromArray(searchData.statusCodes, completed);
            } else if (statusCode == "PENDING") {
                status = this.removeStatusFromArray(searchData.statusCodes, pending);
            } else if (statusCode == "IN_WAREHOUSE") {
                status = this.removeStatusFromArray(searchData.statusCodes, warehouse);
            } else if (statusCode == "SHIPPED") {
                status = this.removeStatusFromArray(searchData.statusCodes, shipped);
            }
        }

        // console.log("NEW STATUS CODES ===== > ", status);
        searchData.statusCodes = status;

        // this.setState({
        //     searchData
        // }, ()=>this.getFilteredOrders());
        this.setState({
            searchData
        }, () => this.getFilteredOrders());

    };

    getFilteredOrders = () => {
        let searchData = {...this.state.searchData};

        // if(this.state.searchData.statusCodes == []){
        //     searchData.statusCodes = [1,4,5,6];
        // }
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };

        if (searchData.searchStartDate !== null && searchData.searchEndDate !== null) {
            searchData.searchStartDate = searchData.searchStartDate + "T00:00:00.000000 ";
            searchData.searchEndDate = searchData.searchEndDate + "T00:00:00.000000 ";
        } else if (searchData.searchStartDate !== null && searchData.searchEndDate == null) {
            searchData.searchStartDate = searchData.searchStartDate + "T00:00:00.000000 ";
            searchData.searchEndDate = null;
        } else {
            searchData.searchStartDate = null;
            searchData.searchEndDate = null;
        }
        // searchData.searchStartDate = new Date(searchData.searchStartDate !== null ? searchData.searchStartDate + " 0:0:0" : null);
        // searchData.searchEndDate = new Date(searchData.searchEndDate !== null ? searchData.searchEndDate + " 0:0:0" : null);
        axios.post(RESOURCE_BASE_URL + 'api/orders/multi-search', searchData, axiosConfig)
            .then((res) => {
                this.setState({
                    orders: res.data.orders,
                    totalItemCount: res.data.rowCount,
                    totalAmount: res.data.totalAmount,
                    allOrderCount: res.data.allOrderCount,
                    dollarAmount: res.data.dollarAmount
                });


            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });
    };


    getAllOrders = (offset, limit) => {
        let searchData = {...this.state.searchData};

        searchData.statusCodes = ["PENDING", "IN_PRODUCTION", "IN_WAREHOUSE", "SHIPPED", "DELIVERED"];

        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };
        axios.post(RESOURCE_BASE_URL + 'api/orders/multi-search', searchData, axiosConfig)
            .then((res) => {
                // console.log("FILTERED ORDERS ==== > ", res.data);
                this.setState({
                    orders: res.data.orders,
                    totalItemCount: res.data.rowCount
                });

            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });

    };

    getOrdersById = (event) => {
        // console.log("Searching....");
        // if (event.target.value === "") {
        //     this.getAllOrders(0, ITEM_COUNT_PER_PAGE)
        // } else {
        //     axios.get(RESOURCE_BASE_URL + 'api/admin/orders/search/' + event.target.value + '?offset=' + 0 + '&limit=' + ITEM_COUNT_PER_PAGE)
        //         .then((res) => {
        //             this.setState({
        //                 orders: res.data.order,
        //                 totalItemCount: res.data.rowCount
        //             });
        //             console.log(res.data);
        //         })
        //         .catch((err) => {
        //             console.log("[API] ERROR: ", err);
        //         });
        // }

    };

    getFilteredOrdersByDateRange = (from, to) => {
        if (from !== "" && to !== "") {
            axios.get(RESOURCE_BASE_URL + 'api/orders/search?from=' + from + '&to=' + to)
                .then((res) => {
                    this.setState({
                        orders: res.data,
                    });
                    // console.log(res.data);
                })
                .catch((err) => {
                    console.log("[API] ERROR: ", err);
                });

            // console.log("calling filter");
        }
    };

    getAllOrdersByDateRange = (event) => {
        // console.log("Name ======> ", event.target.value);
        if (event.target.name === "from") {
            this.setState({
                filterFrom: event.target.value + " 00:00:00.000000"
            }, () => this.getFilteredOrdersByDateRange(this.state.filterFrom, this.state.filterTo));

        } else if (event.target.name === "to") {
            this.setState({
                filterTo: event.target.value + " 00:00:00.000000"
            }, () => this.getFilteredOrdersByDateRange(this.state.filterFrom, this.state.filterTo));

        }
    };

    base64ToArrayBuffer = (base64) => {
        // let binaryString = window.atob(base64);
        let binaryLen = base64.length;
        let bytes = new Uint8Array(binaryLen);
        for (let i = 0; i < binaryLen; i++) {
            let ascii = base64.charCodeAt(i);
            bytes[i] = ascii;
        }
        // console.log("64to",bytes);
        return bytes;
    };

    saveByteArray = (reportName, byte) => {
        // let bytes = new Uint8Array(byte);
        let blob = new Blob([byte], {type: "data:text/csv;charset=utf-8;"});
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        let fileName = reportName;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    exportSalesToCsv = () => {
        let searchData = {...this.state.searchData};

        if (this.state.searchData.statusCodes == []) {
            searchData.statusCodes = ["PENDING", "IN_PRODUCTION", "IN_WAREHOUSE", "SHIPPED", "DELIVERED"];
        }
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };
        let today = new Date().toString();
        searchData.searchStartDate = new Date(searchData.searchStartDate !== null ? searchData.searchStartDate + " 0:0:0" : null);
        searchData.searchEndDate = new Date(searchData.searchEndDate === null ? today : searchData.searchEndDate + " 0:0:0" );
        let fileDate = new Date();
        let editMinutes = fileDate.getMinutes();
        if (editMinutes < 10) {
            editMinutes = "0" + editMinutes;
        }
        console.log("SEARCH DATA ===> ", searchData);
        axios.post(RESOURCE_BASE_URL + 'api/admin/orders/export-orders', searchData, axiosConfig)
            .then((res) => {
                // let sales = this.base64ToArrayBuffer(res.data);
                this.saveByteArray("Sales_list_" + fileDate.getFullYear() + ("0" + (fileDate.getMonth() + 1)).slice(-2) + ("0" + fileDate.getDate()).slice(-2)
                    + fileDate.getHours() + editMinutes + ".csv", res.data);
                // console.log("cvs data ", res.data);
            })
            .catch((err) => {
                console.log("[API] ERROR: cvs data  ", err);
            });
    };

    render() {
        let no = 1 + ((this.state.activePage - 1) * ITEM_COUNT_PER_PAGE);
        /* console.log("SEARCH ORDERS =======> ", this.state.orders);
         console.log("SEARCH da =======> ", this.state.searchData);*/
        return (
            <div className="row">
                <div className="row">
                    <div className="col-md-6">
                        <div className="title-1">
                            {/*<FormattedMessage id="app.all-sales-title.title"
                                              defaultMessage="SALES"
                                              description=""/>*/}
                            受注一覧
                        </div>
                    </div>
                    <div>
                        <div className="col-md-6">
                            {/*<button className="btn btn-success pull-right">
                                <FormattedMessage id="app.order.all.btn.download"
                                                  defaultMessage="Download"
                                                  description=""/>
                                <span className="glyphicon caret"></span>
                            </button>*/}
                        </div>

                    </div>
                </div>
                <hr/>
                <div className="row pull-right" id="sales-download-btn">
                    <button className="btn btn-warning" onClick={this.exportSalesToCsv}>
                        {/*<FormattedMessage id="app.order.all.download-csv"
                                          defaultMessage="Download as CSV File"
                                          description=""/>*/}
                        注文一覧ダウンロード
                    </button>
                </div>
                <SalesTableHeader
                    setSearchStatus={this.setSearchStatus}
                    setSearchTimePeriod={this.setSearchTimePeriod}
                    setSearchTimeRange={this.setSearchTimeRange}
                    getAllOrders={this.getAllOrders}
                    orders={this.state.orders}
                    totalAmount={this.state.totalAmount}
                    allOrderCount={this.state.allOrderCount}
                    dollarAmount={this.state.dollarAmount}
                    handleSearchType={this.handleSearchType}
                    hideOrderStatus={this.state.hideOrderStatus}

                />
                <br/>

                <div className="admin-tables">
                    <div className="admin-table-row-content">
                        <table className="table table-bordered table-all-orders-resp">
                            <SalesTableHeaderRes
                                hideOrderStatus={this.state.hideOrderStatus}
                            />
                            <tbody>
                            {this.state.orders.length !== 0 ?

                                this.state.orders.map(orders => {
                                    return <SalesTableRow key={orders.id} no={no++}
                                                          orders={orders}
                                                          filterdSearchValues={this.state.searchData}
                                                          hideOrderStatus={this.state.hideOrderStatus}/>
                                }) : <tr><td colSpan={7}>
                                    <div className="text-center"><FormattedMessage id="app.order.all.no-records"
                                                                                   defaultMessage="No Records Found"
                                                                                   description=""/></div>
                                </td></tr>
                            }
                            </tbody>
                        </table>

                    </div>
                </div>


                <AllSalesBottom activePage={this.state.activePage}
                                itemsCountPerPage={ITEM_COUNT_PER_PAGE}
                                totalItemsCount={this.state.totalItemCount}
                                handlePageChange={this.handlePageChange}/>
            </div>

        )
    }
}

export default AllOrdersTable;



// WEBPACK FOOTER //
// ./src/components/Admin/Sales/ViewAllSales/AllSalesTable/AllSalesTable.js